import { userRoleTitle } from "app/UtilitiesAndConstants/UtilityFunctions/userRoleUtils";

import type { ISharingModalState } from "./types";

export const getUpdatedSharingState = (
    sharedWithUsers: number[],
    sharedWithInvitations: number[],
    id: number,
    sharedWithUsersToShow: number[],
    sharing: ISharingModalState,
    isInvite: boolean,
): ISharingModalState => {
    const sharedWithUpdated = isInvite
        ? sharedWithInvitations.filter((userId) => userId !== id)
        : sharedWithUsers.filter((userId) => userId !== id);
    const sharedWithUsersToShowUpdated = sharedWithUsersToShow.filter((userId) => userId !== id);
    const usersUpdatedKey = isInvite ? Object.keys({ sharedWithInvitations })[0] : Object.keys({ sharedWithUsers })[0];
    const sharingUpdated = {
        ...sharing,
        [usersUpdatedKey]: sharedWithUpdated,
        sharedWithUsersToShow: sharedWithUsersToShowUpdated,
    };

    return sharingUpdated;
};

export const getMyUserInfo = (id: number, email: string, firstName: string, lastName: string) => {
    return {
        id,
        email,
        firstName,
        lastName,
        role: userRoleTitle.ADMIN,
        isInvite: false,
        text: `${firstName} ${lastName}`,
        isMyUser: true,
        isValid: true,
    };
};
